angular.module('TetherApp').controller('BroadcastController', [
    'DATE_FORMAT',
    '$window',
    '$location',
    '$mdDialog',
    'broadcastService',
    'campaignService',
    function (
        DATE_FORMAT,
        $window,
        $location,
        $mdDialog,
        broadcastService,
        campaignService
    ) {
        let ctrl = this;
        let currentDate;
        let current = [];
        current.title = 'Today';
        ctrl.broadcasts = {};
        ctrl.currentDateTime = new Date();
        ctrl.DATE_FORMAT = DATE_FORMAT;
        ctrl.loadStatus = false;
        ctrl.pagination = {};
        ctrl.pageNum = 1;
        ctrl.selectedType = 'all';

        ctrl.loadBroadcasts = function (pageNum) {
            ctrl.loadStatus = false;
            ctrl.broadcasts = [];
            broadcastService.getBroadcast(ctrl.selectedType, pageNum)
                .then(onBroadcasts, onError);
        };

        let onBroadcasts = function (data) {
            ctrl.pagination = {
                current_page: data.current_page,
                next_page_url: data.next_page_url,
                prev_page_url: data.prev_page_url
            };
            ctrl.broadcasts = data.data;
            ctrl.loadStatus = true;
        };

        let onError = function (data) {
            // console.log('error');
        };

        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = ctrl;
            dCtrl.message = undefined;
            dCtrl.broadcast = ctrl.viewParticipantsPopupBroadcast;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };

            let onSend = function (data) {
                // console.log('success');
            };

            let onError = function (data) {
                // console.log('error');
            };

        };

        ctrl.composePopup = function (ev) {
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'composePopupController',
                bindToController: true,
                templateUrl: '/broadcast/partials/compose-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        ctrl.detailsPopup = function (ev) {
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'detailsPopupController',
                bindToController: true,
                templateUrl: '/broadcast/broadcast-content-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        ctrl.editBroadcastPopup = function (ev, broadcast) {
            ctrl.currentBroadcast = broadcast;
            campaignService.list(true)
                .then(onCampaign, onError);
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'editBroadcastPopupController',
                bindToController: true,
                templateUrl: '/broadcast/partials/edit-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };

        let onCampaign = function (data) {
            ctrl.campaigns = data;
        }

        ctrl.cancelBroadcast = function (id) {
            if ($window.confirm(ctrl.cancelText)) {
                broadcastService.cancelBroadcast(id)
                    .then(onCancel, onError);
            }
        };

        ctrl.sendNow = function (id) {
            if ($window.confirm("Do you wish to send this broadcast now?")) {
                // broadcastService.cancelBroadcast(id)
                //     .then(onCancel, onError);
            }
        };

        let onCancel = function (data) {
            ctrl.loadBroadcasts();
        };

        ctrl.updateLoadStatus = function () {
            ctrl.loadStatus = true;
        };

        ctrl.viewParticipantsPopup = function (ev, broadcast, callback1) {

            ctrl.currentBroadcast = broadcast;
            ctrl.viewParticipantsPopupCallback = callback1;
            ctrl.viewParticipantsPopupEvent = ev;
            ctrl.viewParticipantsPopupBroadcast = broadcast;
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'viewParticipantsPopupController',
                bindToController: true,
                templateUrl: '/broadcast/partials/view-participants-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });
        };
    }
]);
